export enum UserActionResolution {
  Accept = 'Accept',
  Reject = 'Reject'
}
